<template>
  <div class="sidebar shadow-sm p-2 m-0">
      <button @click="goToMostRecentOrder" class="icon-btn">
          <i class="fa fa-forward" aria-hidden="true"></i>
      </button>
      <router-link :to="{ name: 'DashboardHome'       }"><i class="fa fa-file-invoice-dollar" title="home" aria-hidden="true"></i></router-link>

      <template v-if="can('access-admin-sidebar')">
          <router-link :to="{ name: 'ManufacturerSearch'  }"><i class="fa fa-tools" title="Manufacturer Search" aria-hidden="true"></i></router-link>
          <router-link :to="{ name: 'DealerSearch'        }"><i class="fa fa-building" title="Dealer Search" aria-hidden="true"></i></router-link>
          <router-link :to="{ name: 'CustomerSearch'      }"><i class="fa fa-handshake" title="Customer Search" aria-hidden="true"></i></router-link>
          <router-link :to="{ name: 'CoworkerSearch'      }"><i class="fa fa-users" title="Coworker Search" aria-hidden="true"></i></router-link>
          <router-link :to="{ name: 'ProductSearch'       }"><i class="fa fa-file" title="Product Search" aria-hidden="true"></i></router-link>
          <router-link :to="{ name: 'AdminUsers'          }"><i class="fa fa-user-plus" title="Admin Management" aria-hidden="true"></i></router-link>
      </template>

      <template v-if="can('access-tenant-sidebar')">
          <router-link :to="{ name: 'CustomerSearch'      }"><i class="fa fa-handshake" title="Customer Search" aria-hidden="true"></i></router-link>
          <router-link :to="{ name: 'CoworkerSearch'      }"><i class="fa fa-users" title="Coworker Search" aria-hidden="true"></i></router-link>
          <router-link :to="{ name: 'ManufacturerSearch'  }"><i class="fa fa-tools" title="Manufacturer Search" aria-hidden="true"></i></router-link>
          <router-link :to="{ name: 'ProductSearch'       }"><i class="fa fa-file" title="Product Search" aria-hidden="true"></i></router-link>
      </template>

      <template v-if="can('access-tenant-user-admin')">
          <router-link :to="{ name: 'DealerUsers', params: { id: currentUser.DealerId }}"><i class="fa fa-user-plus" title="User Management" aria-hidden="true"></i></router-link>
      </template>

      <template v-if="can('access-tenant-sidebar')">
          <a class="p2"
             v-for="iconObj in customIcons"
             :key="iconObj.IconURL"
             target="_blank"
             :href="iconObj.IconAnchor"
             :title="iconObj.IconLabel">
              <img :src="iconObj.IconURL" :alt="iconObj.IconLabel" height="24px" >
          </a>
      </template>
  </div>
</template>

<script>
    import { mapState } from 'vuex';
    import { DealerService, OrderService } from '@/services';

    export default {
      data: () => {
         return {
             customIcons: []
         }
      },
      computed: {
          ...mapState(['currentUser']),
      },
      methods: {
          goToMostRecentOrder(){
            OrderService.mostRecent()
                .then(res => {
                this.$router.push({ name: 'CustomerOrderEdit', params: { id: res.Id, cid: res.CustomerId } } );
                })
                .catch(err => {
                console.log(err)
                })
            },
          getCustomIcons(){
              let dealerId = this.currentUser.DealerId;
              if (!dealerId) return;
              DealerService.customIcons(dealerId).then(res => {
                  console.log(res)
                  this.customIcons = res;
              }).catch(err => {
                  console.error(err);
              })
          }
      },
      mounted(){
         this.getCustomIcons();
      }
    }
</script>

<style lang="scss" scoped>
  .sidebar{
    min-width: 50px;
    max-width: 50px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-content: center;
    background-color: $ss-blue-extra-light;
    .icon-btn{
        border: none;
        background-color: transparent;
        color: $primary;
        padding: 0px;
        font-size: 24px;
    }
    a{
      display: flex;
      justify-content: center;
      align-content: center;
      margin: 8px 0px;
    }
    i{
      font-size: 24px;
    }
  }
</style>
